import React, { Component } from 'react';
import { Form} from 'semantic-ui-react';
import { connect } from 'react-redux';
import { withTranslation } from "react-i18next";
import { compose } from 'redux';

class ProjectTypeForm extends Component {
    constructor() {
        super();
        this.state = {
            errInputMsg: {}
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            errInputMsg: nextProps.isError
        });
    }

    handleChangeInput = (evt) =>{
        this.props.changeProjectType(evt);
    }
    
    render() {
        const { projectTypeData, t } = this.props;
        return (            
            <div className="employee-form">
                <Form>
                    <Form.Group inline className="form-required">
                        <label>{t('labels.projectTypeCode')}</label>
                        <Form.Input name="projectTypeCode" maxLength="12" 
                            value={projectTypeData.projectTypeCode} 
                            onChange={e => {this.handleChangeInput(e)}}
                        />
                    </Form.Group>
                    <div className="error-message form-list-message">{t(this.state.errInputMsg['projectTypeCode'])}</div>
                    <Form.Group inline className="form-required">
                        <label>{t('labels.description')}</label>
                        <Form.Input name="projectTypeName" 
                            value={projectTypeData.projectTypeName} 
                            onChange={e => {this.handleChangeInput(e)}}
                            maxLength="50"
                        />
                    </Form.Group>
                    <div className="error-message form-list-message">{t(this.state.errInputMsg['projectTypeName'])}</div>
                </Form>
            </div>
        );
    }
}

const mapStateToProps = state => ({
})

const mapDispatchToProps = dispatch => ({
})

export default compose(
    withTranslation(),
    connect(mapStateToProps, mapDispatchToProps)
)(ProjectTypeForm);
